import Box from "@mui/material/Box";
import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import { background } from "src/styles";

export const Tokenpaper = (props: any) => {
  return (
    
    <Paper
      elevation={0}
      
      sx={{
        marginBottom: 1,
        background: "#000",
        borderRadius: 2,
        marginX: 2,
        // padding: 2,
        // backgroundColor: "red",
      }}
    >
      <Box
        display={"flex"}
        flexDirection="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Box margin={2}>{props.image}</Box>
        <Box>
          <Box textAlign={"left"}>{props.title}</Box>
          <Box>{props.para}</Box>
        </Box>
      </Box>
    </Paper>
   
  );
};
